export default productId => productId === 'bookshelf-all'
